import { combineReducers } from 'redux';

import {
    REQUEST_ACCOUNT_GODCHILDREN,
    RECEIVE_ACCOUNT_GODCHILDREN,
    FAILURE_ACCOUNT_GODCHILDREN
} from './constants';
import {
    SEND_INVITATION_REMINDS_SUCCESS,
    SEND_PURCHASE_REMINDS_SUCCESS
} from '../../sponsorship/constants';
import { RESET_ACCOUNT_USER } from '../constants';

const godchildren = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_GODCHILDREN:
            return action.response.payload.godsons;
        case SEND_PURCHASE_REMINDS_SUCCESS:
            return action.response.payload.godsons;
        case RESET_ACCOUNT_USER:
            return [];
        default:
            return state;
    }
};
const requests = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_GODCHILDREN:
            return action.response.payload.requests;
        case SEND_INVITATION_REMINDS_SUCCESS:
            if (!action.response.payload) {
                return [...state];
            }
            const id = action.response.payload[0].id;
            const filteredRequests = [...state].filter(r => r.id !== id);
            const newRequests = [...filteredRequests, action.response.payload[0]].sort(
                (a, b) => a.id < b.id
            );
            return newRequests;
        case RESET_ACCOUNT_USER:
            return [];
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ACCOUNT_GODCHILDREN:
            return true;
        case FAILURE_ACCOUNT_GODCHILDREN:
        case RECEIVE_ACCOUNT_GODCHILDREN:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ACCOUNT_GODCHILDREN:
            return action.response.message;
        case REQUEST_ACCOUNT_GODCHILDREN:
        case RECEIVE_ACCOUNT_GODCHILDREN:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    godchildren,
    requests,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/godchildren/reducer.js